import { StorageService } from '@wlp/ui-bs-oauth';
import { ModalExtractReviewComponent } from './../../../../../../modals/modal-extract-review/modal-extract-review.component';
import { ExtractService } from '@wlp/ui-bs-cashout';
import { ModalTokenComponent } from './../../../../../../modals/modal-token/modal-token.component';
import { UserInfoService } from '@wlp/ui-bs-login';
import { LoadingService } from './../../../../../../../../../core/layout/services/loading.service';

import { FormGroup } from '@angular/forms';
import { NavController, ModalController } from '@ionic/angular';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { Component, OnInit } from '@angular/core';
import { ConsultDetranService, PaymentDetranService } from '@wlp/ui-bs-detran';
import { TokenCodeService } from '@wlp/ui-bs-token';
import { interval, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ModalAlertComponent } from 'src/app/views/themes/sentinel/modals/modal-alert/modal-alert.component';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';

@Component({
  selector: 'payment-resume',
  templateUrl: './payment-resume.component.html',
  styleUrls: ['./payment-resume.component.scss']
})
export class PaymentResumeDetran implements OnInit {

  iconName: string | 'eye-off-outline' | 'eye-outline';
  balanceTitle: string;
  titleHeader: string;
  backgroundHeaderLogon: any;
  listStates: Array<any>
  listOperations: any;
  objectPayment = {
    codeAuthorization: '',
    operationValue: 0,
    uuidDetranVehicleAccount: '',
    transactionId: '',
    type: '',
    uf: '',
    uuidAccountPayment: '',
    uuidWhiteLabel: '',
    paymentDescription: '',
    paymentCardCVV: '',
    paymentCardInstallments: '',
    paymentCardName: '',
    paymentCardNumber: '',
    paymentCardValidDate: '',
    paymentType: '',
    primaryDescription: '',
    listDetranItens: []
  };


  public formConsult: FormGroup;
  public listDataResume: {}[];
  public paymentData: any;
  public errorMessages: any;

  userProfile: any;
  interval: any;
  subscription: any;
  transferDataReceipt: any;
  title: string;
  confirmation: any;
  showResume: boolean = false;

  formPayment: FormGroup;
  listInstallments: number[];
  paymentsType: any[];
  isEnabledPayment: boolean;

  private readonly OPERATION: string = '920';
  uuidDetranVehicleAccount: any;
  totalValue: number;
  listItemSelected: any[];

  constructor(
    private layoutConfigService: LayoutConfigService,
    private navController: NavController,
    private consultDetranService: ConsultDetranService,
    private paymentService: PaymentDetranService,
    private load: LoadingService,
    private authService: UserInfoService,
    private tokenCodeService: TokenCodeService,
    private router: Router,
    private modalController: ModalController,
    private translate: UiBsTranslateService,
    private storageSerive: StorageService
  ) { }

  ngOnInit() {
    this.iconName = 'eye-off-outline';
    this.backgroundHeaderLogon = this.layoutConfigService.getConfig('wlTheme.header.background.image');

    if (this.router.getCurrentNavigation().extras.state == undefined) {
      this.navController.navigateRoot(['/app/payment/detran/consult']);
    } else {
      this.paymentData = this.router.getCurrentNavigation().extras.state.data;
      this.totalValue = this.router.getCurrentNavigation().extras.state.totalValue;
      this.listItemSelected = this.router.getCurrentNavigation().extras.state.listItemSelected;
      this.storageSerive.get('uuidVehicle').then(res => {
        this.uuidDetranVehicleAccount = res;
      })
      this.prepareDataResume();
    }

    this.formConsult = this.consultDetranService.getFormSubject().getValue();
    this.formPayment = this.paymentService.createForm();
    this.errorMessages = this.paymentService.getErrosMessages();
    this.listInstallments = this.paymentService.getInstallments();

    this.loadUser();


  }

  continue() {
    this.token()
  }

  prepareDataResume() {
    this.listDataResume = [
      {
        name: this.translate.applyTranslate('CASH_OUT.DETRAN.LABELS.RENAVAM'),
        value: this.paymentData.vehicleRenavam ? this.paymentData.vehicleRenavam : this.formConsult.get('renavam').value
      },
      {
        name: this.translate.applyTranslate('CASH_OUT.DETRAN.LABELS.UF'),
        value: this.paymentData.vehicleUf ? this.paymentData.vehicleUf : this.formConsult.get('uf').value
      },
    ]

    if (!!this.paymentData.vehicleOwner) {
      this.listDataResume.push({
        name: this.translate.applyTranslate('CASH_OUT.DETRAN.LABELS.VEHICLE_OWNER'),
        value: this.paymentData.vehicleOwner
      })
    };
    if (!!this.paymentData.vehicleCity) {
      this.listDataResume.push(
        {
          name: this.translate.applyTranslate('CASH_OUT.DETRAN.LABELS.CITY'),
          value: this.paymentData.vehicleCity
        }
      )
    };

    for (let index = 0; index < this.paymentData.debits.length; index++) {
      if (index === this.paymentData.debits.length) {
        this.objectPayment.primaryDescription += `${this.paymentData.debits[index].title}`;
      } else {
        this.objectPayment.primaryDescription += `${this.paymentData.debits[index].title} | `;
      }
    }
    this.listDataResume.push({
      name: this.translate.applyTranslate('CASH_OUT.DETRAN.LABELS.OPERATION'),
      value: this.objectPayment.primaryDescription
    })
  }

  loadUser() {
    this.authService.getInfoProfile().then((res) => {
      this.load.show();
      this.userProfile = res;
      this.consultDetranService.getPaymentsType(this.userProfile.uuidAccount).subscribe(res => {
        this.paymentsType = res;
        this.load.hide()
      })
      this.load.hide()
    }).catch(err => {
      this.load.hide()
    })
  }

  preparePayment() {
    (this.objectPayment.operationValue = this.totalValue,
      this.objectPayment.uuidDetranVehicleAccount = this.uuidDetranVehicleAccount,
      this.objectPayment.transactionId = "",
      this.objectPayment.type = this.formConsult.get('operation').value,
      this.objectPayment.uf = this.paymentData.vehicleUf,
      this.objectPayment.uuidAccountPayment = this.userProfile.uuidAccount,
      this.objectPayment.uuidWhiteLabel = this.userProfile.uuidWhiteLabel,
      this.objectPayment.paymentCardName = this.formPayment.get('nameCard').value ? this.formPayment.get('nameCard').value : '',
      this.objectPayment.paymentCardNumber = this.formPayment.get('numberCard').value ? this.formPayment.get('numberCard').value : '',
      this.objectPayment.paymentCardCVV = this.formPayment.get('cvv').value ? this.formPayment.get('cvv').value : '',
      this.objectPayment.paymentCardInstallments = this.formPayment.get('numberInstallments').value ? this.formPayment.get('numberInstallments').value : '',
      this.objectPayment.paymentType = this.formPayment.get('paymentType').value,
      this.objectPayment.paymentCardValidDate = this.formPayment.get('validity').value,
      this.objectPayment.listDetranItens = this.listItemSelected
    )
  }

  dismiss() {
    this.navController.back()
  }

  public async token() {
    const modalToken = await this.modalController.create({
      component: ModalTokenComponent,
      cssClass: 'modal-token',
      componentProps: {
        validationOnly: true,
        codeOperation: this.OPERATION
      },
    });
    modalToken.onDidDismiss().then((data) => {
      if (data['data']) {
        this.objectPayment.codeAuthorization = data.role;
        this.sendPayment();
      }
    });
    return await modalToken.present();
  }

  sendPayment() {
    try {
      this.load.show()
      this.paymentService.payment(this.objectPayment)
        .subscribe(res => {
          if (!res) {
            this.notification('warning-circle', this.translate.applyTranslate('CASH_OUT.DETRAN.MESSAGES.FAILED'), false);
          } else
            if (!res.isExecuted) {
              this.notification('warning-circle', res.message, false);
            } else {
              this.navController.navigateRoot(['/app/payment/detran/payment-receipt-detran'], { state: { transactionId: res.transactionId } })
            }
        }, (err) => {
          this.notification('warning-circle', this.translate.applyTranslate('CASH_OUT.DETRAN.MESSAGES.FAILED'), false);
          this.load.hide()
        })
    } catch (error) {
      this.load.hide()
    }
  }

  cancel() {
    this.showResume = false;
  }

  paymentType(ev) {
    /* console.log(ev) */
  }

  backToDebitsList() {
    this.navController.navigateRoot(['/app/payment/detran/consult']);
  }

  gotToResume() {
    this.showResume = true;
    this.preparePayment();
  }

  enabledPayment(event) {
    this.isEnabledPayment = event;
  }

  private async notification(status: string, message: string, confirmation?: boolean) {
    const modalSuccess = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status,
        message,
        confirmBtn: 'OK',
        confirmation,
        translate: true,
      },
      backdropDismiss: false,
    });

    return await modalSuccess.present();
  }
}
